import React, {
    useState
} from "react";

import {
    useLocation,
    useNavigate,
    useParams
} from "react-router-dom";

import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import "./ShowFreeResult.css";


function ShowPrimePaperResult() {

    const navigate =
        useNavigate();


    const {
        historyId
    } = useParams();


    const location =
        useLocation();


    /*
    |--------------------------------------------------------------------------
    | Sidebar
    |--------------------------------------------------------------------------
    */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);


    /*
    |--------------------------------------------------------------------------
    | User Name
    |--------------------------------------------------------------------------
    */

    const name =
        Cookies.get("username") ||
        "Student";


    /*
    |--------------------------------------------------------------------------
    | Result Data
    |--------------------------------------------------------------------------
    */

    const apiResult =
        location.state?.result ||
        null;


    const result =
        apiResult?.data &&
        typeof apiResult.data === "object"

            ? apiResult.data

            : apiResult;


    /*
    |--------------------------------------------------------------------------
    | Paper
    |--------------------------------------------------------------------------
    */

    const paper =
        location.state?.paper ||
        result?.paper ||
        null;


    /*
    |--------------------------------------------------------------------------
    | Debug
    |--------------------------------------------------------------------------
    */

    console.log(
        "SHOW PREMIUM PAPER RESULT LOCATION STATE:",
        location.state
    );


    console.log(
        "SHOW PREMIUM PAPER RESULT API RESULT:",
        apiResult
    );


    console.log(
        "SHOW PREMIUM PAPER RESULT DATA:",
        result
    );


    console.log(
        "SHOW PREMIUM PAPER PAPER:",
        paper
    );


    /*
    |--------------------------------------------------------------------------
    | Back To Premium Papers
    |--------------------------------------------------------------------------
    */

    function handleBackToPapers() {

        navigate(
            "/premium-paper-categories"
        );

    }


    /*
    |--------------------------------------------------------------------------
    | Result Missing
    |--------------------------------------------------------------------------
    */

    if (
        !result ||
        !Array.isArray(result.review)
    ) {

        return (

            <div className="user-dashboard">

                <UserSidebar
                    sidebarOpen={
                        sidebarOpen
                    }
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <main className="dashboard-main">

                    <UserHeader
                        name={name}
                        setSidebarOpen={
                            setSidebarOpen
                        }
                    />


                    <div className="dashboard-content py-4 px-3 px-md-4">

                        <div className="show-result-container">

                            <div className="result-empty-box">

                                <div className="result-empty-icon">

                                    <i className="bi bi-file-earmark-x"></i>

                                </div>


                                <h3>
                                    Result Not Found
                                </h3>


                                <p>
                                    Result information is not available.
                                    Please go back to Premium Papers.
                                </p>


                                <button
                                    type="button"
                                    className="result-back-btn"
                                    onClick={
                                        handleBackToPapers
                                    }
                                >

                                    <i className="bi bi-arrow-left"></i>

                                    Back to Premium Papers

                                </button>

                            </div>

                        </div>

                    </div>

                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Review
    |--------------------------------------------------------------------------
    */

    const review =
        Array.isArray(result.review)
            ? result.review
            : [];


    /*
    |--------------------------------------------------------------------------
    | Total Questions
    |--------------------------------------------------------------------------
    */

    const totalQuestions =
        Number(
            result.total_questions ??
            review.length ??
            0
        );


    /*
    |--------------------------------------------------------------------------
    | Attempted
    |--------------------------------------------------------------------------
    */

    const attempted =
        Number(
            result.attempted ??
            0
        );


    /*
    |--------------------------------------------------------------------------
    | Correct
    |--------------------------------------------------------------------------
    */

    const correct =
        Number(
            result.correct ??
            0
        );


    /*
    |--------------------------------------------------------------------------
    | Wrong
    |--------------------------------------------------------------------------
    */

    const wrong =
        Number(
            result.wrong ??
            result.incorrect ??
            0
        );


    /*
    |--------------------------------------------------------------------------
    | Unanswered
    |--------------------------------------------------------------------------
    */

    const unanswered =
        Number(
            result.unanswered ??
            result.skipped ??
            0
        );


    /*
    |--------------------------------------------------------------------------
    | Score
    |--------------------------------------------------------------------------
    */

    const score =
        Number(
            result.score ??
            0
        );


    /*
    |--------------------------------------------------------------------------
    | Attempt Number
    |--------------------------------------------------------------------------
    */

    const reattempt =
        Number(
            result.reattempt ??
            0
        );


    const attemptNumber =
        Number(
            result.attempt_number ??
            (
                reattempt === 0
                    ? 1
                    : 2
            )
        );


    /*
    |--------------------------------------------------------------------------
    | Marks Per Question - DYNAMIC
    |--------------------------------------------------------------------------
    */

    const marksPerQuestion =
        Number(
            result.marks ??
            result.paper?.marks ??
            paper?.marks ??
            1
        );


    /*
    |--------------------------------------------------------------------------
    | TOTAL MARKS - DYNAMIC
    |--------------------------------------------------------------------------
    */

    const totalMarks =
        Number(
            result.total_marks ??
            (
                Number(totalQuestions) *
                Number(marksPerQuestion)
            )
        );


    /*
    |--------------------------------------------------------------------------
    | Negative Marks
    |--------------------------------------------------------------------------
    */

    const negativeMarks =
        Number(
            result.negative_marks ??
            result.paper?.negative_marks ??
            paper?.negative_marks ??
            0
        );


    /*
    |--------------------------------------------------------------------------
    | Percentage
    |--------------------------------------------------------------------------
    */

    const percentage =
        result.percentage !== undefined &&
        result.percentage !== null

            ? Math.round(
                Number(
                    result.percentage
                )
            )

            : totalMarks > 0

                ? Math.max(
                    0,
                    Math.round(
                        (
                            score /
                            totalMarks
                        ) * 100
                    )
                )

                : 0;


    /*
    |--------------------------------------------------------------------------
    | Debug Final Values
    |--------------------------------------------------------------------------
    */

    console.log(
        "FINAL PREMIUM PAPER RESULT VALUES:",
        {
            historyId,

            totalQuestions,

            marksPerQuestion,

            totalMarks,

            attempted,

            correct,

            wrong,

            unanswered,

            score,

            percentage,

            negativeMarks,

            attemptNumber,

            result,

            paper
        }
    );


    /*
    |--------------------------------------------------------------------------
    | Practice Again
    |--------------------------------------------------------------------------
    */

    const handlePracticeAgain = () => {

        if (
            !paper?.paper_id
        ) {

            return;

        }


        navigate(
            `/premium-paper/start/${encodeURIComponent(
                paper.paper_id
            )}`,
            {
                replace: true
            }
        );

    };


    /*
    |--------------------------------------------------------------------------
    | OPTION NORMALIZER
    |--------------------------------------------------------------------------
    |
    | Backend:
    |
    | 1 = A
    | 2 = B
    | 3 = C
    | 4 = D
    |
    | Frontend:
    | Always A/B/C/D
    |--------------------------------------------------------------------------
    */

    const normalizeOption = (
        option
    ) => {

        const value =
            String(
                option ?? ""
            )
                .trim()
                .toUpperCase();


        if (
            value === "A" ||
            value === "1"
        ) {

            return "A";

        }


        if (
            value === "B" ||
            value === "2"
        ) {

            return "B";

        }


        if (
            value === "C" ||
            value === "3"
        ) {

            return "C";

        }


        if (
            value === "D" ||
            value === "4"
        ) {

            return "D";

        }


        return "0";

    };


    /*
    |--------------------------------------------------------------------------
    | OPTION TEXT
    |--------------------------------------------------------------------------
    */

    const getOptionText = (
        item,
        option
    ) => {

        const normalizedOption =
            normalizeOption(
                option
            );


        if (
            normalizedOption === "A"
        ) {

            return (
                item?.option1 ||
                ""
            );

        }


        if (
            normalizedOption === "B"
        ) {

            return (
                item?.option2 ||
                ""
            );

        }


        if (
            normalizedOption === "C"
        ) {

            return (
                item?.option3 ||
                ""
            );

        }


        if (
            normalizedOption === "D"
        ) {

            return (
                item?.option4 ||
                ""
            );

        }


        return "";

    };


    /*
    |--------------------------------------------------------------------------
    | OPTION LABEL
    |--------------------------------------------------------------------------
    |
    | This function guarantees that
    | Your Answer / Correct Answer
    | will display only A/B/C/D.
    |--------------------------------------------------------------------------
    */

    const getOptionLabel = (
        option
    ) => {

        const normalizedOption =
            normalizeOption(
                option
            );


        if (
            normalizedOption === "A"
        ) {

            return "A";

        }


        if (
            normalizedOption === "B"
        ) {

            return "B";

        }


        if (
            normalizedOption === "C"
        ) {

            return "C";

        }


        if (
            normalizedOption === "D"
        ) {

            return "D";

        }


        return "-";

    };


    /*
    |--------------------------------------------------------------------------
    | Render
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard">

            <UserSidebar
                sidebarOpen={
                    sidebarOpen
                }
                setSidebarOpen={
                    setSidebarOpen
                }
            />


            <main className="dashboard-main">

                <UserHeader
                    name={name}
                    setSidebarOpen={
                        setSidebarOpen
                    }
                />


                <div className="dashboard-content py-4 px-3 px-md-4">

                    <div className="show-result-container">


                        {/* ======================================================
                            RESULT HEADER
                        ====================================================== */}

                        <div className="result-header-card">

                            <div className="result-header-content">

                                <span className="result-small-title">

                                    PREMIUM PAPER RESULT

                                </span>


                                <h1>

                                    {
                                        paper?.paper ||
                                        result.paper?.paper ||
                                        `Paper #${
                                            paper?.paper_id ||
                                            result.paper_id ||
                                            historyId
                                        }`

                                    }

                                </h1>


                                <p>

                                    Attempt{" "}

                                    {attemptNumber}

                                </p>

                            </div>


                            <div className="result-score-circle">

                                <strong>

                                    {percentage}%

                                </strong>


                                <span>

                                    Score

                                </span>

                            </div>

                        </div>


                        {/* ======================================================
                            SUMMARY
                        ====================================================== */}

                        <div className="result-summary-grid">


                            {/* Total Questions */}

                            <div className="result-summary-card summary-total">

                                <div className="result-summary-icon">

                                    <i className="bi bi-list-check"></i>

                                </div>


                                <div>

                                    <span>
                                        Total Questions
                                    </span>


                                    <strong>
                                        {totalQuestions}
                                    </strong>

                                </div>

                            </div>


                            {/* Correct */}

                            <div className="result-summary-card summary-correct">

                                <div className="result-summary-icon">

                                    <i className="bi bi-check-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Correct
                                    </span>


                                    <strong>
                                        {correct}
                                    </strong>

                                </div>

                            </div>


                            {/* Wrong */}

                            <div className="result-summary-card summary-wrong">

                                <div className="result-summary-icon">

                                    <i className="bi bi-x-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Wrong
                                    </span>


                                    <strong>
                                        {wrong}
                                    </strong>

                                </div>

                            </div>


                            {/* Unanswered */}

                            <div className="result-summary-card summary-unanswered">

                                <div className="result-summary-icon">

                                    <i className="bi bi-dash-circle"></i>

                                </div>


                                <div>

                                    <span>
                                        Unanswered
                                    </span>


                                    <strong>
                                        {unanswered}
                                    </strong>

                                </div>

                            </div>


                            {/* Attempted */}

                            <div className="result-summary-card summary-attempted">

                                <div className="result-summary-icon">

                                    <i className="bi bi-pencil-square"></i>

                                </div>


                                <div>

                                    <span>
                                        Attempted
                                    </span>


                                    <strong>
                                        {attempted}
                                    </strong>

                                </div>

                            </div>


                            {/* Score */}

                            <div className="result-summary-card summary-score">

                                <div className="result-summary-icon">

                                    <i className="bi bi-award"></i>

                                </div>


                                <div>

                                    <span>
                                        Score
                                    </span>


                                    <strong>

                                        {score}
                                        /
                                        {totalMarks}

                                    </strong>

                                </div>

                            </div>

                        </div>


                        {/* ======================================================
                            QUESTION REVIEW
                        ====================================================== */}

                        <div className="question-review-section">

                            <div className="question-review-heading">

                                <div>

                                    <span>
                                        QUESTION REVIEW
                                    </span>


                                    <h2>
                                        Review Your Answers
                                    </h2>

                                </div>


                                <div className="review-count">

                                    {review.length}

                                    {" "}

                                    Questions

                                </div>

                            </div>


                            {review.map(
                                (
                                    item,
                                    index
                                ) => {

                                    /*
                                    |--------------------------------------------------------------------------
                                    | Selected Option
                                    |--------------------------------------------------------------------------
                                    |
                                    | IMPORTANT:
                                    | 1/2/3/4 -> A/B/C/D
                                    |--------------------------------------------------------------------------
                                    */

                                    const selectedOption =
                                        normalizeOption(
                                            item?.selected_option
                                        );


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Correct Option
                                    |--------------------------------------------------------------------------
                                    */

                                    const correctOption =
                                        normalizeOption(
                                            item?.correct_option
                                        );


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Status
                                    |--------------------------------------------------------------------------
                                    */

                                    const status =
                                        String(
                                            item?.status ??
                                            ""
                                        )
                                            .trim()
                                            .toLowerCase();


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Correct
                                    |--------------------------------------------------------------------------
                                    */

                                    const isCorrect =
                                        item?.is_correct === true ||
                                        item?.is_correct === 1 ||
                                        item?.is_correct === "1" ||
                                        status === "correct";


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Unanswered
                                    |--------------------------------------------------------------------------
                                    */

                                    const isUnanswered =
                                        selectedOption === "0" ||
                                        status === "unanswered";


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Selected Text
                                    |--------------------------------------------------------------------------
                                    */

                                    const selectedText =
                                        getOptionText(
                                            item,
                                            selectedOption
                                        );


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Correct Text
                                    |--------------------------------------------------------------------------
                                    */

                                    const correctText =
                                        getOptionText(
                                            item,
                                            correctOption
                                        );


                                    /*
                                    |--------------------------------------------------------------------------
                                    | Final Status
                                    |--------------------------------------------------------------------------
                                    */

                                    const finalStatus =
                                        isUnanswered

                                            ? "unanswered"

                                            : isCorrect

                                                ? "correct"

                                                : "wrong";


                                    return (

                                        <div
                                            key={
                                                item?.question_id ||
                                                index
                                            }
                                            className={
                                                `result-question-card ${
                                                    finalStatus
                                                }`
                                            }
                                        >


                                            {/* ==========================================
                                                QUESTION TOP
                                            ========================================== */}

                                            <div className="result-question-top">

                                                <div className="result-question-number">

                                                    Q{" "}

                                                    {String(
                                                        index + 1
                                                    ).padStart(
                                                        2,
                                                        "0"
                                                    )}

                                                </div>


                                                <div
                                                    className={
                                                        `question-status-badge ${
                                                            finalStatus
                                                        }`
                                                    }
                                                >

                                                    {finalStatus ===
                                                        "correct" && (

                                                        <>

                                                            <i className="bi bi-check-circle-fill"></i>

                                                            Correct

                                                        </>

                                                    )}


                                                    {finalStatus ===
                                                        "wrong" && (

                                                        <>

                                                            <i className="bi bi-x-circle-fill"></i>

                                                            Wrong

                                                        </>

                                                    )}


                                                    {finalStatus ===
                                                        "unanswered" && (

                                                        <>

                                                            <i className="bi bi-dash-circle-fill"></i>

                                                            Unanswered

                                                        </>

                                                    )}

                                                </div>

                                            </div>


                                            {/* ==========================================
                                                QUESTION
                                            ========================================== */}

                                            <div
                                                className="result-question-text"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        item?.question ||
                                                        ""
                                                }}
                                            />


                                            {/* ==========================================
                                                OPTIONS
                                            ========================================== */}

                                            <div className="result-options">

                                                {[
                                                    "A",
                                                    "B",
                                                    "C",
                                                    "D"
                                                ].map(
                                                    option => {

                                                        const optionText =
                                                            getOptionText(
                                                                item,
                                                                option
                                                            );


                                                        const isSelected =
                                                            selectedOption ===
                                                            option;


                                                        const isCorrectOption =
                                                            correctOption ===
                                                            option;


                                                        let optionClass =
                                                            "result-option";


                                                        /*
                                                        |--------------------------------------------------------------------------
                                                        | Correct Option
                                                        |--------------------------------------------------------------------------
                                                        */

                                                        if (
                                                            isCorrectOption
                                                        ) {

                                                            optionClass +=
                                                                " result-option-correct";

                                                        }


                                                        /*
                                                        |--------------------------------------------------------------------------
                                                        | Wrong Selected Option
                                                        |--------------------------------------------------------------------------
                                                        */

                                                        if (
                                                            isSelected &&
                                                            !isCorrectOption
                                                        ) {

                                                            optionClass +=
                                                                " result-option-wrong";

                                                        }


                                                        /*
                                                        |--------------------------------------------------------------------------
                                                        | Selected Correct Option
                                                        |--------------------------------------------------------------------------
                                                        */

                                                        if (
                                                            isSelected &&
                                                            isCorrectOption
                                                        ) {

                                                            optionClass +=
                                                                " result-option-selected-correct";

                                                        }


                                                        return (

                                                            <div
                                                                key={
                                                                    option
                                                                }
                                                                className={
                                                                    optionClass
                                                                }
                                                            >

                                                                <div className="result-option-letter">

                                                                    {option}

                                                                </div>


                                                                <div
                                                                    className="result-option-text"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html:
                                                                            optionText
                                                                    }}
                                                                />


                                                                <div className="result-option-status">


                                                                    {isCorrectOption && (

                                                                        <span className="correct-label">

                                                                            <i className="bi bi-check-circle-fill"></i>

                                                                            Correct Answer

                                                                        </span>

                                                                    )}


                                                                    {isSelected &&
                                                                        !isCorrectOption && (

                                                                            <span className="wrong-label">

                                                                                <i className="bi bi-x-circle-fill"></i>

                                                                                Your Answer

                                                                            </span>

                                                                        )
                                                                    }


                                                                </div>

                                                            </div>

                                                        );

                                                    }
                                                )}

                                            </div>


                                            {/* ==========================================
                                                ANSWER INFORMATION
                                            ========================================== */}

                                            <div className="answer-information">


                                                <div className="answer-info-item">

                                                    <span>
                                                        Your Answer
                                                    </span>


                                                    <strong
                                                        className={
                                                            isUnanswered

                                                                ? "unanswered-text"

                                                                : isCorrect

                                                                    ? "correct-text"

                                                                    : "wrong-text"
                                                        }
                                                    >

                                                        {isUnanswered

                                                            ? "Not Answered"

                                                            : (
                                                                <>
                                                                    {getOptionLabel(
                                                                        selectedOption
                                                                    )}

                                                                    {
                                                                        selectedText
                                                                            ? ` - ${selectedText}`
                                                                            : ""
                                                                    }
                                                                </>
                                                            )

                                                        }

                                                    </strong>

                                                </div>


                                                <div className="answer-info-item">

                                                    <span>
                                                        Correct Answer
                                                    </span>


                                                    <strong className="correct-text">

                                                        {
                                                            correctOption !== "0"

                                                                ? getOptionLabel(
                                                                    correctOption
                                                                )

                                                                : "Not Available"
                                                        }


                                                        {
                                                            correctOption !== "0" &&
                                                            correctText
                                                                ? ` - ${correctText}`
                                                                : ""
                                                        }

                                                    </strong>

                                                </div>

                                            </div>


                                            {/* ==========================================
                                                EXPLANATION
                                            ========================================== */}

                                            <div className="result-explanation">

                                                <div className="result-explanation-title">

                                                    <i className="bi bi-lightbulb-fill"></i>

                                                    Explanation

                                                </div>


                                                <div
                                                    className="result-explanation-content"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            item?.explanation ||
                                                            "<p>Explanation not available.</p>"
                                                    }}
                                                />

                                            </div>

                                        </div>

                                    );

                                }
                            )}

                        </div>


                        {/* ======================================================
                            FOOTER BUTTONS
                        ====================================================== */}

                        <div className="result-action-buttons">


                            {attemptNumber < 2 && (

                                <button
                                    type="button"
                                    className="result-practice-btn"
                                    onClick={
                                        handlePracticeAgain
                                    }
                                >

                                    <i className="bi bi-arrow-repeat"></i>

                                    Practice Again

                                </button>

                            )}


                            <button
                                type="button"
                                className="result-back-btn"
                                onClick={
                                    handleBackToPapers
                                }
                            >

                                <i className="bi bi-arrow-left"></i>

                                Back to Premium Papers

                            </button>

                        </div>


                    </div>

                </div>

            </main>

        </div>

    );

}


export default ShowPrimePaperResult;